import React from 'react';
import StackForm from './StackForm';

/**
 * The page behind `/manual-create-stack` — **Analyze Current Stack**.
 *
 * The route name is historical and stays (ruled, STACK-544): it was the manual
 * stack editor until 2026-09-12, when the entry point was retired for this
 * redesign. What it serves now is the analysis flow — the member lists what
 * they already take, names one health goal, and gets back what the research
 * says about it. `StackForm` in create mode *is* that flow; edit mode
 * (`/edit-stack/:id`) is the same component with `isEditMode`.
 *
 * It stays a component of its own rather than becoming `<StackForm />` inline
 * in `App.js` so the route reads as a page, and so this comment has somewhere
 * to live — "manual create" does not say "analyze" to anyone reading the route
 * table.
 */
function ManualCreateStack() {
  return <StackForm isEditMode={false} />;
}

export default ManualCreateStack;
